import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Button, Grid } from '@mui/material';

const Home = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h3" gutterBottom align="center">
        Joon Health Tools
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        <Grid item>
          <Button
            component={Link}
            to="/bcba-goal-generator"
            variant="contained"
            color="primary"
            size="large"
          >
            BCBA Goal Generator
          </Button>
        </Grid>
        <Grid item>
          <Button
            component={Link}
            to="/task-analysis-builder"
            variant="contained"
            color="primary"
            size="large"
          >
            Task Analysis Builder
          </Button>
        </Grid>
        <Grid item>
          <Button
            component={Link}
            to="/session-note-summarizer"
            variant="contained"
            color="primary"
            size="large"
          >
            Session Note Summarizer
          </Button>
        </Grid>
        <Grid item>
        <Button
          component={Link}
          to="/data-collection-helper"
          variant="contained"
          color="primary"
          size="large"
        >
          Data Collection Helper
        </Button>
      </Grid>
         <Grid item>
          <Button
            component={Link}
            to="/bcba-roi-calculator"
            variant="contained"
            color="primary"
            size="large"
          >
            Joon Health ROI Calculator
          </Button>
        </Grid>
        <Grid item>
        <Button
          component={Link}
          to="/bcba-utilization-calculator"
          variant="contained"
          color="primary"
          size="large"
        >
          BCBA Utilization Calculator
        </Button>
      </Grid>
      <Grid item>
        <Button
          component={Link}
          to="/goal-writing-assistant"
          variant="contained"
          color="primary"
          size="large"
        >
          Goal Writing Assistant
        </Button>
        </Grid>
        <Grid item>
          <Button
            component={Link}
            to="/progress-note-template-creator"
            variant="contained"
            color="primary"
            size="large"
          >
            Progress Note Template Creator
          </Button>
        </Grid>
        <Grid item>
        <Button
          component={Link}
          to="/pricing-calculator"
          variant="contained"
          color="primary"
          size="large"
        >
          Pricing Calculator
        </Button>
      </Grid>
      <Grid item>
          <Button
            component={Link}
            to="/intervention-strategy-generator"
            variant="contained"
            color="primary"
            size="large"
          >
            Intervention Strategy Generator
          </Button>
        </Grid>
        <Grid item>
          <Button
            component={Link}
            to="/bip-template-generator"
            variant="contained"
            color="primary"
            size="large"
          >
            BIP Template Generator
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Home;